import React, { useState } from 'react';
import { Button } from '../ui/button';
import {Cell} from "./bidConfig_model";

interface PasteFromExcelProps {
  className?: string;
  pasteDataFromExcel: (data: any[]) => void
}


export function PasteDataToCellsBidder(target: Cell[][] | null, pasteData: any[]){
    if(!target){
        return []
    }
    // console.log(pasteData.length)
    const copiedArray = target.map(subArray => [...subArray]);
    for (let i = 0; i < target.length; i++) {

        if(pasteData.length > i){

            for (let j = 0; j < target[0].length; j++) {
                //
                if (target[i][j].party === true && pasteData[i].cells.length > j) {
                    // console.log('set', i, j, target[i][j], pasteData[i].cells[j])
                    copiedArray[i][j].value = pasteData[i].cells[j]
                }

            }
        }
    }
    return copiedArray
}


// excel's clipboard text -> rows of cells. it ends with a newline - no empty last row for it
export function parseClipboard(text: string): string[][] {
    const rows = text.replace(/\r/g, "").split("\n").map((row) => row.split("\t"));
    if (rows.length > 1 && rows[rows.length - 1].join("") === "") {
        rows.pop();
    }
    return rows;
}

const PasteFromExcel: React.FC<PasteFromExcelProps> = ({ className, pasteDataFromExcel }) => {
    const handleClick = async () => {
        try {
            const text = await navigator.clipboard.readText();
            const rowData = parseClipboard(text).map(cells => ({cells}));
            pasteDataFromExcel(rowData)
        } catch (error) {
            console.error('Failed to read clipboard contents: ', error);
        }
    };

    return (
        <div className={className}>
            <Button variant="outline" onClick={handleClick}>Paste from excel</Button>
        </div>
    );
};

export default PasteFromExcel;
